import { Loading } from 'components'
import React from 'react'

type DataStatusProfitNLossType = {
  loading: boolean
}

export const DataStatusProfitNLoss = ({ loading }: DataStatusProfitNLossType) => (
  <tr>
    <td colSpan={10} className="text-center">
      <Loading
        loading={loading}
        errorText={loading ? "" : "No data available"}
      />
    </td>
  </tr>
)